import { Badge, type BadgeProps } from '@opengoal/ui';
import { useTranslation } from 'react-i18next';
import type { ContractStatus, ContractType } from '@/api/generated/model';
import { STATUS_VARIANT } from '../../lib/contractMeta';

export function ContractStatusBadge({ status }: { status: ContractStatus }) {
  const { t } = useTranslation();
  return <Badge variant={STATUS_VARIANT[status]}>{t(`contracts.status.${status}`)}</Badge>;
}

export function ContractTypeBadge({ type }: { type: ContractType }) {
  const { t } = useTranslation();
  return <Badge variant="outline">{t(`contracts.type.${type}`)}</Badge>;
}

/**
 * Days to the end date as the API computed them. Hidden for a terminated
 * contract, whose end date is no longer anyone's deadline.
 */
export function DaysBadge({ days, status }: { days: number; status: ContractStatus }) {
  const { t } = useTranslation();
  if (status === 'terminated') return null;
  const variant: BadgeProps['variant'] = days < 0 ? 'danger' : days <= 90 ? 'warning' : 'success';
  return (
    <Badge variant={variant} shape="pill">
      {days < 0
        ? t('contracts.daysOverdue', { count: Math.abs(days) })
        : t('contracts.daysRemaining', { count: days })}
    </Badge>
  );
}
